

export interface UploadFile {
    name: string;
    size: number;
    type: string;
    content: string | ArrayBuffer | null;
}

export var uploadFilesList = new Array<UploadFile>();

export function deleteFromList (elName: string) {
    for(let idx: number = 0; idx<uploadFilesList.length; idx++) {
        if(elName === uploadFilesList[idx].name) {
            uploadFilesList.splice(idx, 1);
        }
    }

}


export function addToList(fname: string, fsize: number, ftype: string, fcontent: string | ArrayBuffer | null) {
    uploadFilesList.push( { name: fname, size: fsize, type: ftype, content: fcontent} );
}
